// extracted by mini-css-extract-plugin
export default {"description":"LandingEco_description__X1NJf","image":"LandingEco_image__dtQmO","info":"LandingEco_info__iYsql"};